import React from 'react';
import PropTypes from 'prop-types';
// import tc from 'tinycolor2';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBannerWithButton from '../../components/ContentBannerWithButton';
import FYHMenu from '../../components/menus/FYH';


const styles = css`
.PageSection_wrapper {
  max-width: 100%;
  padding: 20px 0;
  @media (min-width: 768px) {
    padding: 50px 0;
  }
}
.SectionContentBanner {
  padding: 20px 0;
  @media (min-width: 768px) {
    padding: 30px 0;
  }
}

`;


function Investment({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <FYHMenu />
      <ContentBannerWithButton
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
        btn={get(welcome, 'pdf_button', [])}

      />
      <div className="PageSection_wrapper">
        <div className="container">
          {
          get(page, 'content_banner') && get(page, 'content_banner').length > 0 &&
           get(page, 'content_banner').map(item => (
             <div key={item._id} className="SectionContentBanner">
               <h3 className="PageSection_title">{item.title}</h3>
               <span className="PageSection_copy" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'copy'))} />
             </div>
           ))
          }
        </div>
      </div>
    </PageWrapper>
  );
}

Investment.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'investment',
})(Investment);



// WEBPACK FOOTER //
// ./src/pages/Investment/index.js